<div class="howto-row">
  <button (click)="save()"
          class="simpleSaveButton btn btn-primary"
          color="primary">Save</button>

  <div [dragula]="'card-bag'"
       [dragulaModel]="cards">
    <div class="row card-row"
         *ngFor="let card of cards; let i = index">
      <div class="col-md-9">
        <div class="col-sm-3">
          <h4>Title:</h4>
          <input [(ngModel)]="card.title"
                 pInputText
                 type="text" />
        </div>
        <div class="col-sm-9 d-flex flex-wrap">

          <div>
            <h4>Body:</h4>
            <textarea [froalaEditor]="options"
                      [(froalaModel)]="card.body"
                      class="full-width"></textarea>
          </div>
        </div>
      </div>
      <div class="col-sm-3 mt-5">
        <span class="mx-5"> Position: {{ i+1 }}</span>

        <span class="sm-padding-top ml-5">
          <i class="fa fa-times fa-col removeUrl"
             (click)="removeCard(i)"
             aria-hidden="true"></i>
        </span>
      </div>
      <div class="col-md-12">
        <div class="col-md-2 d-flex align-items-center justify-content-center">
          <img class="img-responsive icon-image"
               src={{card.imageUrl}}
               alt={{card.imageAlt}} />
        </div>
        <div class="col-md-4">
          <h4>Image Url:</h4>
          <input [(ngModel)]="card.imageUrl"
                 pInputText
                 type="text" />
        </div>
        <div class="col-md-6">
          <h4>Image Alt Text:</h4>
          <input [(ngModel)]="card.imageAlt"
                 pInputText
                 type="text" />
        </div>
      </div>

    </div>

    <div class="my-3">
      <button (click)="addCard()"
              class="btn btn-secondary">
        Add card
      </button></div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/components/howto-row/howto-row.component.html